import { render, staticRenderFns } from "./report-interaction-tab.vue?vue&type=template&id=0b928b86&scoped=true"
import script from "./report-interaction-tab.vue?vue&type=script&lang=js"
export * from "./report-interaction-tab.vue?vue&type=script&lang=js"
import style0 from "./report-interaction-tab.vue?vue&type=style&index=0&id=0b928b86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b928b86",
  null
  
)

export default component.exports